import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { sortCaret } from "../../../../../../_metronic/_helpers/index.js"
import { Card, CardBody, CardHeader } from "../../../../../../_metronic/_partials/controls/index.js"
import { DetailSvgIcon } from "../../../../../../component/atoms/Icons/SVG/index.jsx"
import TableView, { formatterRowComponent } from "../../../../../../component/atoms/Tabel/index.jsx"
import { TableSkeleton } from "../../../../../../component/index.jsx"
import { timeStampToDate } from "../../../../../helpers/DateHelper.js"
import { useTranslation } from "react-i18next"
import { checkBadgePaymentStatus, stringFormatting, toRupiah } from "../../../../../helpers/TextHelper.js"
import { ACTIVITY_TYPE_ENUM } from "../../../../../../constants/StringConstant.js"

export const AreaList = ({ data, general, changePage, title, onClickDetail, payment }) => {
  const { t } = useTranslation()
  const uiType = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">
          {stringFormatting(e?.activity_name)}{" "}
          {e.is_seedling_package &&
            (e.activity_type_enum === ACTIVITY_TYPE_ENUM.PLANTING ||
              e.activity_type_enum === ACTIVITY_TYPE_ENUM.SEEDLING) &&
            `${t("label_seedling_package")}`}
        </p>
      </>
    )
  }
  const uiHST = (e) => {
    return (
      <>
        <p className="text-dark mb-1 font-size-lg">{e?.hst ?? "-"}</p>
      </>
    )
  }
  const uiActivityDate = (e) => {
    return (
      <>
        <p className="text-dark mb-1 font-size-lg">
          {e?.activity_date ? timeStampToDate(e?.activity_date, "dd-MM-yyyy") : "-"}
        </p>
      </>
    )
  }

  const uiCreatedDate = (e) => {
    return (
      <>
        <p className="text-dark mb-1 font-size-lg">
          {e?.submitted_date ? timeStampToDate(e?.submitted_date, "dd-MM-yyyy") : "-"}
        </p>
        <p className="text-dark mb-1 font-size-lg">
          {e?.submitted_date ? timeStampToDate(e?.submitted_date, "HH:mm:ss") : "-"}
        </p>
      </>
    )
  }
  const uiSubmit = (e) => {
    return (
      <>
        <p className="text-dark font-weight-bolder mb-1 font-size-lg">{e?.submitted_by ?? "-"}</p>
        <span className="text-muted font-weight-bold d-block">{e?.submitted_phone ?? "-"}</span>
      </>
    )
  }
  const uiAction = (item) => {
    return (
      <>
        <OverlayTrigger overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}>
          <a
            onClick={() => {
              onClickDetail(item.id, item?.activity_type_enum?.toLowerCase())
            }}
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3">
            <DetailSvgIcon></DetailSvgIcon>
          </a>
        </OverlayTrigger>
      </>
    )
  }

  const uiTotalActivity = (item) => {
    return (
      <>
        <p className="text-dark mb-1 font-size-lg">{toRupiah(item?.total_bill)}</p>
      </>
    )
  }

  const uiRemainingBill = (item) => {
    return (
      <>
        <p className="text-dark mb-1 font-size-lg">{toRupiah(item?.remaining_bill)}</p>
      </>
    )
  }
  const uiBillStatus = (item) => {
    return (
      <>
        <p>{item?.payment_status ? checkBadgePaymentStatus(item?.payment_status) : "-"}</p>
      </>
    )
  }

  const columns = [
    {
      dataField: "activity_name",
      text: t("table_header_activity_type"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiType
      }
    },
    {
      dataField: "activityDate",
      text: t("table_header_activity_date"),
      sort: true,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiActivityDate
      }
    },
    {
      dataField: "hst",
      text: "HST",
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiHST
      }
    },
    {
      dataField: "submitted_by",
      text: t("table_header_submit_by"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiSubmit
      }
    },
    {
      dataField: "createdDate",
      text: t("table_header_created_date"),
      sort: true,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCreatedDate
      }
    },
    ...(payment
      ? [
        {
          dataField: "totalBill",
          text: t("total_bills"),
          sort: true,
          sortCaret: sortCaret,
          formatter: formatterRowComponent,
          formatExtraData: {
            externalStyle: uiTotalActivity
          }
        },
        {
          dataField: "remainingBill",
          text: t("remaining_bill"),
          sort: true,
          sortCaret: sortCaret,
          formatter: formatterRowComponent,
          formatExtraData: {
            externalStyle: uiRemainingBill
          }
        },
        {
          dataField: "paymentStatus",
          text: t("bill_status"),
          sort: true,
          sortCaret: sortCaret,
          formatter: formatterRowComponent,
          formatExtraData: {
            externalStyle: uiBillStatus
          }
        },
      ]
      : []),
    {
      dataField: "action",
      text: "ACTION",
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiAction
      }
    }
  ]

  return (
    <>
      {general.loading ? (
        <TableSkeleton column={6} row={10} />
      ) : (
        <Card className="card-shadowless">
          {title && <CardHeader title={title} />}

          <CardBody>
            <TableView
              callbackAfterPageChange={changePage}
              columnProperties={columns}
              dataTable={data?.pageData}
              currentPage={data?.page?.currentPage}
              currentElement={data?.page?.currentElement}
              totalCount={data?.page?.totalCount}
              loadingGetData={general?.loading}
              ignoreSinglePage
              rowClasses={() => {
                return ""
              }}
              rowEvents={{
                onClick: () => {}
              }}
            />
          </CardBody>
        </Card>
      )}
    </>
  )
}